<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            <h4>Crawl Todo</h4>
            <div class="text-muted">Only {{ total }} more shows to check this run</div>
          </CCardHeader>
          <CCardBody>
            <CrawlTodoTable :items="items" :active-page="activePage" :pages="pages" />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CrawlTodoTable from './CrawlTodoTable'
import { mapGetters } from 'vuex'

export default {
  name: 'Crawler',
  components: { CrawlTodoTable },
  data() {
    return {
      limit: 10,
    }
  },
  watch: {
    activePage() {
      this.getData()
    },
  },
  mounted() {
    if (this.total > 0) {
      // apperently we've been here before
      if (this.paged > 1) {
        // works for first page: need a reload here cause of activePage
        this.$router.push({ query: { page: this.paged } })
      }
    } else {
      this.getData()
    }
  },
  destroyed() {
    this.$store.dispatch('closeError')
  },
  computed: {
    activePage() {
      const { query } = this.$route
      return query && query.page ? Number(query.page) : 1
    },
    pages() {
      return Math.ceil(this.total / this.limit)
    },
    ...mapGetters({
      items: 'crawltodo',
      total: 'crawltodoTotal',
    }),
  },
  methods: {
    rowClicked(item) {
      this.$router.push({ path: `podcasts/${item.podcast_id}` })
    },

    getData(triggerSearch = false) {
      this.$store.dispatch('getCrawlTodo', {
        $api: this.$api,
        limit: this.limit,
        page: triggerSearch ? 1 : this.activePage,
      })
    },
  },
}
</script>

<style>
.clear-icon .btn {
  height: 24px;
  padding: 0;
  margin: -4px;
}
.clear-icon .input-group-append > .input-group-text {
  background-color: white;
}
</style>
